/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\empty.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


export const SET_EMPTY = 'SET_EMPTY';
export const UNSET_EMPTY = 'NO_EMPTY';


// TODO: optimize with inline
function setEmpty(is_empty) {
  if (is_empty) {
    return {
      type: SET_EMPTY,
    };
  }
  return {
    type: UNSET_EMPTY,
  };
}

export default setEmpty;



// WEBPACK FOOTER //
// ./src/redux/actions/empty.js